import { useEffect } from 'react';

export const useLightMode = (isLightMode) => {
  useEffect(() => {
    const body = document.body;
    const signinPageContainer = document.querySelector('.signin-page-container');
    const signinBoxi = document.querySelector('.signin-boxi');
    const forgotPassword = document.querySelector('.gn-forgoti-password');

    if (isLightMode) {
      body.classList.add('light-mode');
      body.classList.remove('dark-mode');

      if (signinPageContainer) {
        signinPageContainer.classList.add('light-mode');
        signinPageContainer.classList.remove('dark-mode');
      }

      // if (signinBoxi) {
      //   signinBoxi.classList.add('light-mode');
      //   signinBoxi.classList.remove('dark-mode');
      // }

      // if (forgotPassword) {
      //   forgotPassword.classList.add('light-mode');
      //   forgotPassword.classList.remove('dark-mode');
      // }
    } else {
      body.classList.remove('light-mode');
      body.classList.add('dark-mode');

      if (signinPageContainer) {
        signinPageContainer.classList.add('dark-mode');
        signinPageContainer.classList.remove('light-mode');
      }

      // if (signinBoxi) {
      //   signinBoxi.classList.add('dark-mode');
      //   signinBoxi.classList.remove('light-mode');
      // }

      // if (forgotPassword) {
      //   forgotPassword.classList.add('dark-mode');
      //   forgotPassword.classList.remove('light-mode');
      // }
    }
  }, [isLightMode]);
};
